/**
 * @desc WMS调拨单修改目的仓
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanAllocationEditRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/editAllocationTargetWarehouse`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
